module.exports = __webpack_public_path__ + "static/media/walk.1f05fa79.svg";